import { Component, ElementRef, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/_service/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/_service/common.service';
import { cities } from 'indian-cities-json';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-visitorrequest',
	templateUrl: './visitorrequest.component.html',
	styleUrls: ['./visitorrequest.component.scss']
})
export class VisitorrequestComponent implements AfterViewInit {
  isActive = '';
  isEnglish = true;
  showUploadPhoto = true;
  cameraImageUpload: boolean = false;
  cameraImage: string | ArrayBuffer = null;
  imageSrc: string | ArrayBuffer | null = null;
  stream: MediaStream | null = null;
  captures: string[] = []; // Array to store captured images
  visitorEntry: any = {
    // Language:"English",
    ImageFileName: '',
    ImageFile: "",
    AccessInfo: {},
    Address: '',
    PhoneNumber: '',
    VisitorName: '',
    DateOfBirth: '',
    ReferenceName: '',
    Purpose: '',
    VistorPriority: {
      VistorPriorityId: 1,
      VisitorPriorityColor: "#fff",
    },
    Search:{
      Language: 'English',
      ConstituencyType:null,
      VidhanSabha:null,
      PanchayatSamiti:null,
      GramPanchayat:null,
      GramVillage:null,
      VisitorName:null,
      PhoneNumber:null,
      ReferenceName:null,
      StartDate:null,
      EndDate:null,
     }
  }; // Your model
submitted:boolean=false;
  // ViewChild references for video and canvas elements
  @ViewChild('video', {
    static: false
  }) public video: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas', {
    static: false
  }) public canvas: ElementRef<HTMLCanvasElement>;

  vsObject: any = {
    AccessInfo: {},
  }
  psObject: any = {
    AccessInfo: {},
    VidhanSabha: {}
  }
  gpObject: any = {
    AccessInfo: {},
    PachaytSamiti: {}
  }
  gvObject: any = {
    AccessInfo: {},
    GramPanchayat: {}
  }
  city: any = {
    State: {},
  }
  vsDropdownList: any[] = [];
  psDropdownList: any[] = [];
  gpDropdownList: any[] = [];
  gvDropdownList: any[] = [];
  stateArr: any[] = [];
  cityArr: any[] = [];
  isEdit: boolean=false;
  submittedother: boolean;
  disablecapture: boolean;

  constructor(
    public dialog: MatDialog,
    private locationn: Location,
    private renderer: Renderer2, private appService: AppService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private common: CommonService
  ) {
    const data = JSON.parse(localStorage.getItem('office_q_uid'));
    if (data && data.UserId) {
      this.vsObject.AccessInfo.UserId = data.UserId;
      this.psObject.AccessInfo.UserId = data.UserId;
      this.gpObject.AccessInfo.UserId = data.UserId;
      this.gvObject.AccessInfo.UserId = data.UserId;
      this.visitorEntry.AccessInfo.UserId = data.UserId;
    }else{

    }

    if (data && data.UserLocationId) {
      this.vsObject.AccessInfo.UserLocationId = data.UserLocationId;
      this.psObject.AccessInfo.UserLocationId = data.UserLocationId;
      this.gpObject.AccessInfo.UserLocationId = data.UserLocationId;
      this.gvObject.AccessInfo.UserLocationId = data.UserLocationId;
      this.visitorEntry.AccessInfo.UserLocationId = data.UserLocationId;
    }

    if (data && data.CompanyId) {
      this.vsObject.AccessInfo.CompanyId = data.CompanyId;
      this.psObject.AccessInfo.CompanyId = data.CompanyId;
      this.gpObject.AccessInfo.CompanyId = data.CompanyId;
      this.gvObject.AccessInfo.CompanyId = data.CompanyId;
      this.visitorEntry.AccessInfo.CompanyId = data.CompanyId;
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const companyId = params['CompanyId'];
      const locationId = params['locationId'];

      if (companyId) {
        this.vsObject.AccessInfo.CompanyId = companyId;
        this.psObject.AccessInfo.CompanyId = companyId;
        this.gpObject.AccessInfo.CompanyId = companyId;
        this.gvObject.AccessInfo.CompanyId = companyId;
        this.visitorEntry.AccessInfo.CompanyId = companyId;
      }

      if (locationId) {
        this.vsObject.AccessInfo.UserLocationId = locationId;
        this.psObject.AccessInfo.UserLocationId = locationId;
        this.gpObject.AccessInfo.UserLocationId = locationId;
        this.gvObject.AccessInfo.UserLocationId = locationId;
        this.visitorEntry.AccessInfo.UserLocationId = locationId;
      }

      console.log('CompanyId:', this.vsObject);
      // console.log('UserLocationId:', locationId);
    });
    // Additional initialization logic can go here
    console.log('cities: ', cities);
    this.stateArr = [...new Set(cities.map((city: { state: string; name: string }) => city.state))].map((state: string) => ({ StateName: state })).sort((a, b) => a.StateName.localeCompare(b.StateName));
    console.log(' this.stateArr: ',  this.stateArr);
    this.isActive = 'Constituency';
    if (document.getElementById('div_UploadPhoto')) {
      this.renderer.setStyle(document.getElementById('div_UploadPhoto'), 'display', 'block');
      this.playcamera();
    }

    if (document.getElementById('div_CapturePhoto')) {
      this.renderer.setStyle(document.getElementById('div_CapturePhoto'), 'display', 'none');
      this.playcamera();
    }
    this.getVidhanSabhaDropdownList();
    // this.getStateDropdownList();
    this.getVisitor();
    // this.getPanchayatSamitiDropdownList();
    // this.getGramPanchayatDropdownList();
    // this.getGramVillageDropdownList();
  }

  //Adding new Visitor
  addVisitor(v:NgForm,formtype:any) {
  console.log('v: ', v);
  if(formtype=='Other'){
    this.submittedother=true;
  }else{

    this.submitted=true;
  }
    if(v.valid){
      if (this.isActive == "Constituency")
        this.visitorEntry.ConstituencyType = "Constituency";
      else
        this.visitorEntry.ConstituencyType = "Other";
      console.log({ ...this.visitorEntry })

      // this.visitorEntry.DateOfBirth = this.common.convertToLocal(this.visitorEntry.DateOfBirth);
      this.visitorEntry.VistingDate=new Date();
      console.log('   this.visitorEntry.DateOfBirth:',    this.visitorEntry.DateOfBirth);
      // this.visitorEntry.VistingDate = this.common.convertToLocal(this.visitorEntry.VistingDate);
      console.log(' this.visitorEntry.VistingDate: ',  this.visitorEntry.VistingDate);

      this.appService.post2Service({ ...this.visitorEntry }, 'Visitor/VisitorSave')
        .subscribe(response => {
          console.log(response)
          if (response.body.Success) {
            this.router.navigate(['/app/dashboard/visitor']);

            //this.getTaskList();
          }
        });
    }else{
      return;
    }

  }

  getVisitor() {

    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.spinner.show();
        this.visitorEntry.Id = params.id;
        this.appService.post2Service({ ...this.visitorEntry }, 'Visitor/getVisitor')
          .subscribe(response => {
            this.visitorEntry = response.body.Result;
            // this.visitorEntry.DateOfBirth = this.common.convertToLocal(this.visitorEntry.DateOfBirth);
            // this.visitorEntry.VistingDate = this.common.convertToLocal(this.visitorEntry.VistingDate);
            if (this.visitorEntry.ConstituencyType == "Constituency") {
              this.isActive = "Constituency"
              this.psObject.VidhanSabha = this.visitorEntry.VidhanSabha;
              this.getPanchayatSamitiDropdownList();
              this.gpObject.PachaytSamiti = this.visitorEntry.PanchayatSamiti;
              this.getGramPanchayatDropdownList();
              this.gvObject.GramPanchayat = this.visitorEntry.GramPanchayat;
              this.getGramVillageDropdownList();
            } else {
              this.isActive = "Other";
              this.city.State.StateId = this.visitorEntry.State.StateId;
              this.getCityDropdownList();
            }
            this.isEdit=true;
            if(this.visitorEntry.ImageFile){
              this.imageSrc = this.visitorEntry.ImageFile;

            }
            this.isEnglish = this.visitorEntry.Language=='Hindi'?false:true;

            console.log(response)
          })
        //this.task.StartTime = this.dateTimeFormat(this.task.StartTime);
        this.spinner.hide();
      }
    });
  }

  //VidhanSabha Dropdown
  getVidhanSabhaDropdownList() {
    this.appService.post2Service({ ...this.vsObject }, 'VidhanSabha/GetVidhanSabhaDropdownList')
      .subscribe(response => {
        this.vsDropdownList = response.body.Result;
      });
  }

  //PanchayatSamity Dopdown
  getPanchayatSamitiDropdownList() {
    this.appService.post2Service({ ...this.psObject }, 'PanchayatSamiti/GetPanchayatSamitiDropdownList')
      .subscribe(response => {
        this.psDropdownList = response.body.Result;
      });
  }

  //Gram Panchayat Dropdown
  getGramPanchayatDropdownList() {
    this.appService.post2Service({ ...this.gpObject }, 'GramPanchayat/GetGramPanchayatDropdownList')
      .subscribe(response => {
        this.gpDropdownList = response.body.Result;
      });
  }

  //GramVillage Dropdown
  getGramVillageDropdownList() {
    this.appService.post2Service({ ...this.gvObject }, 'GramVillage/GetGramVillageDropdownList')
      .subscribe(response => {
        this.gvDropdownList = response.body.Result;
      });
  }

  getStateDropdownList() {
    this.appService.post2Service({}, 'Visitor/getStates')
      .subscribe(response => {
        this.stateArr = response.body.Result;
      });
  }
  getCityDropdownList() {
    this.appService.postService({ ...this.city }, 'CityDropDownList')
      .subscribe(response => {
        this.cityArr = response.body.Result.CityList;
      });
  }
  selectedVidhanSabha(item: any) {
    this.psObject.VidhanSabha.vs_id = item.value.vs_id;
    this.getPanchayatSamitiDropdownList();
  }
  selectedPanchayatSamity(item: any) {
    this.gpObject.PachaytSamiti.ps_id = item.value.ps_id;
    this.getGramPanchayatDropdownList();
  }
  selectedGramPanchayat(item: any) {
    this.gvObject.GramPanchayat.gp_id = item.value.gp_id;
    this.getGramVillageDropdownList();
  }
  // selectState(item: any) {
  //   this.city.State.StateId = item.value.StateId;
  //   this.getCityDropdownList();
  // }
  selectState(event: any) {
    const selectedState = event.value;
    this.cityArr = cities
      .filter(city => city.state === selectedState.StateName)
      .map(city => ({ CityName: city.name })).sort((a,b)=>a.CityName.localeCompare(b.CityName));

    this.visitorEntry.City = ''; // Reset city selection
  }
  playcamera() {
    this.captures = null;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({
        video: true
      }).then(stream => {
        this.stream = stream; // Save the stream to stop it later
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.play();

      }).catch(error => {
        this.disablecapture=true;
        console.error('Error accessing the camera:', error);

      });
    }
  }

  stopCamera() {
    if (this.stream) {
      // Stop all tracks to ensure the camera turns off
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
      this.video.nativeElement.srcObject = null; // Release the video source
      this.stream = null; // Clear the stream reference
    }
  }


  ngAfterViewInit() {
    // this.playcamera()
    // if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    // 	navigator.mediaDevices.getUserMedia({
    // 		video: true
    // 	}).then(stream => {
    // 		//  this.video.nativeElement.src = window.URL.createObjectURL(stream);
    // 		this.video.nativeElement.srcObject = stream;
    // 		this.video.nativeElement.play();
    // 	});
    // }
  }

  showHideUploadImage() {
    this.imageSrc='';
    this.visitorEntry.ImageFileName = '';
    this.visitorEntry.ImageFile = '';
    this.captures = [];
    this.renderer.setStyle(document.getElementById('div_UploadPhoto'), 'display', 'none');
    this.renderer.setStyle(document.getElementById('div_CapturePhoto'), 'display', 'block');
  }

  HideUploadImage() {

    // this.imageSrc='';
    // this.visitorEntry.ImageFileName = '';
    // this.visitorEntry.ImageFile = '';
    // this.captures = [];
    this.renderer.setStyle(document.getElementById('div_UploadPhoto'), 'display', 'block');
    this.renderer.setStyle(document.getElementById('div_CapturePhoto'), 'display', 'none');

  }

  toggleUploadMode() {
    this.showUploadPhoto = !this.showUploadPhoto;
  }

  toggleCameraUpload(enable: boolean = true) {
    this.cameraImageUpload = enable;
    this.showUploadPhoto = !enable; // Hide upload photo when in camera mode
  }


  capture() {
    // this.showHideUploadImage();
    const context = this.canvas.nativeElement.getContext('2d').drawImage(this.video.nativeElement, 0, 0, 200, 200);

    this.captures = [];
    this.visitorEntry.ImageFileName = this.canvas.nativeElement.toDataURL('image/jpg');
    this.captures.push(this.canvas.nativeElement.toDataURL('image/jpg'));
    this.visitorEntry.ImageFileName = this.visitorEntry.VisitorName + '.png'; //this.makeid(this.captures.length) + '.png';
    this.imageSrc = this.captures.toString();
    console.log('this.imageSrc: ', this.imageSrc);
    this.visitorEntry.ImageFile = this.captures.toString();

  }

  makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  Complete() {
    this.stopCamera();
    this.HideUploadImage();
  }
  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent) => {
        this.cameraImage = (e.target as FileReader).result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  goBack(): void {
    this.locationn.back();
  }

  compareFn(a: any, b: any) {
    if (b) {
      const d = a[Object.keys(a)[0]];
      const e = b[Object.keys(b)[0]];
      return d === e;
    }
  }
  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageSrc = reader.result as string; // Preview the uploaded image
        this.visitorEntry.ImageFileName = file.name; // Store the file name
        this.visitorEntry.ImageFile = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  selectLanguage(item:any){
    if(item.value=="English")
      this.isEnglish=true;
    else
      this.isEnglish=false;
  }
  removeImage(){
    this.imageSrc='';
    this.visitorEntry.ImageFileName='';
    this.visitorEntry.ImageFile='';

  }
  updateAddress(): void {

    const vidhansabha = this.visitorEntry.VidhanSabha
      ? (this.isEnglish
          ? this.visitorEntry.VidhanSabha.VidhanSabhaEnglishName
          : this.visitorEntry.VidhanSabha.VidhanSabhaHindiName)
      : '';

    const panchayatSamiti = this.visitorEntry.PanchayatSamiti
      ? (this.isEnglish
          ? this.visitorEntry.PanchayatSamiti.PanchayatSamitiEnglishName
          : this.visitorEntry.PanchayatSamiti.PanchayatSamitiHindiName)
      : '';

    const gramPanchayat = this.visitorEntry.GramPanchayat
      ? (this.isEnglish
          ? this.visitorEntry.GramPanchayat.GramPanchayatEnglishName
          : this.visitorEntry.GramPanchayat.GramPanchayatHindiName)
      : '';

    const gramVillage = this.visitorEntry.GramVillage
      ? (this.isEnglish
          ? this.visitorEntry.GramVillage.GramVillageEnglishName
          : this.visitorEntry.GramVillage.GramVillageHindiName)
      : '';

    // Construct the address
    if (vidhansabha && panchayatSamiti && gramPanchayat && gramVillage) {
      this.visitorEntry.Address = this.isEnglish
      ? `Vidhan Sabha - ${vidhansabha}, Panchayat Samiti - ${panchayatSamiti}, Gram Panchayat - ${gramPanchayat}, Gram Village - ${gramVillage}`
      : `विधान सभा - ${vidhansabha}, पंचायत समिति - ${panchayatSamiti}, ग्राम पंचायत - ${gramPanchayat}, ग्राम गांव - ${gramVillage}`;

      // Ensure proper font rendering for Hindi by applying a specific font family
      if (!this.isEnglish) {
        const addressElement = document.getElementById('address-display'); // Assuming an element with this ID exists
        if (addressElement) {
          addressElement.style.fontFamily = "'Noto Sans Devanagari', sans-serif"; // Use a font that supports Hindi
        }
      }
    }
  }

  getVisitorList() {
    this.visitorEntry.Search.Language = '';
    this.visitorEntry.Search.PhoneNumber = this.visitorEntry.PhoneNumber;

    this.appService.post2Service({ ...this.visitorEntry }, 'Visitor/VisitorList')
      .subscribe(response => {
        if (response.body && response.body.Result && Array.isArray(response.body.Result)) {
          const visitorList = response.body.Result;

          // Sort by VisitingDate in descending order (latest first)
          visitorList.sort((a, b) => new Date(b.VisitingDate).getTime() - new Date(a.VisitingDate).getTime());
          if(visitorList.PhoneNumber==this.visitorEntry.PhoneNumber){

            this.visitorEntry = visitorList.length > 0 ? visitorList[0] : {};
            // this.setSelectedDropdownValues();
            this.psObject.VidhanSabha = this.visitorEntry.VidhanSabha;
            this.getPanchayatSamitiDropdownList();
            this.gpObject.PachaytSamiti = this.visitorEntry.PanchayatSamiti;
            this.getGramPanchayatDropdownList();
            this.gvObject.GramPanchayat = this.visitorEntry.GramPanchayat;
            this.getGramVillageDropdownList();
            this.imageSrc=this.visitorEntry.ImageFile;
            this.visitorEntry.ImageFileName=this.visitorEntry.ImageFileName;
          }
          // Assign the latest entry
          console.log('Latest visitor entry:', this.visitorEntry);
        }
      });
  }

  onMobileNumberChange(phoneNumber: string): void {
    if (!phoneNumber) return;

    // Remove any whitespace and validate
    phoneNumber = phoneNumber.trim();

    const mobilePattern = /^[6-9]\d{9}$/;

    if (phoneNumber.length === 10 && mobilePattern.test(phoneNumber)) {
      console.log('Valid mobile number entered:', phoneNumber);

      // Call the getVisitorList API
      this.getVisitorList();
    } else {
      console.log('Invalid mobile number:', phoneNumber);
    }
  }
	}
